import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_dlso2ccw88: FaireBrandEntity = {
  token: "b_dlso2ccw88",
  type: "brand",
  name: "Adorable Sweetness",
  avatarUrl:
    "https://cdn.faire.com/fastly/aadb062d055d46a9993f5d05ad55eb23afaf120bc036430268cd3a198aaca18e.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/5264f691b6a571b61db8a6e12e4e73a5c88ffa51d69ce4e09d54bafdf6d30607.png",
  logoUrl:
    "https://cdn.faire.com/fastly/aadb062d055d46a9993f5d05ad55eb23afaf120bc036430268cd3a198aaca18e.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/5264f691b6a571b61db8a6e12e4e73a5c88ffa51d69ce4e09d54bafdf6d30607.png",
  location: "Kaysville, UT, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 455,
  isTopShop: true,
  isInsider: true,
  description:
    'Hello and “Oh My”!\n\nI would like to tell you my story. My name is Heidi, I am the proud owner and operator of Adorable Sweetness, an Online Girls Boutique.  "A Boutique like no other!"\n\nI have an IT degree and worked as an executive in Finance….ugh!... boring!  On a very stressful day, I set out to re-create myself. I took stock of my loves and talents.\n\nAnd then I opened Adorable Sweetness!  My finance and IT background came in handy for running the online store. But, the fun part...is finding the cutest clothes.  I love it when I dress my girls in outfits and get compliments. I smile when people say….”Oh My!  She is so cute, where did you get that outfit from?”.  This is my standard, it must pass the “Oh My” test before it will become part of the Adorable Sweetness brand.\n\nAfter 7 years we are more committed than ever to deliver those cute quality outfits to display the Adorable Sweetness brand that so many have come to love for the “Oh My” moments!\n\nThank you for supporting my small business and for your continued support!\n\nMuch Love,\n\nThe Adorable Sweetness Team',
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:40.327Z",
    importedBy: "entity-db-cli",
  },
};
